"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFileArea = void 0;
const utils_1 = require("@juvare/common-form-ui/WidgetFormFile/Components/utils");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const DriveFolderUpload_1 = __importDefault(require("@mui/icons-material/DriveFolderUpload"));
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const SelectFileArea = (props) => {
    const [dragStatus, setDragStatus] = react_1.default.useState();
    const file = react_1.default.useRef(null);
    const { onSelectFile } = props;
    const processFile = react_1.default.useCallback((file) => {
        onSelectFile(file);
    }, [onSelectFile]);
    const handleRemoveFile = () => {
        if (file.current) {
            file.current.value = '';
        }
        props.onRemoveFile();
    };
    const handleDrop = react_1.default.useCallback((event) => {
        event.preventDefault();
        setDragStatus(undefined);
        const file = findValidFileInDragEvent(event, props.fileInputAccept);
        if (file) {
            processFile(file);
        }
        else {
            (0, DialogHelper_1.showErrorDialog)({
                title: 'Not a ' + props.fileTypeLabel + ' selected',
                onClose: () => undefined,
            });
        }
    }, [processFile, props.fileTypeLabel, props.fileInputAccept]);
    const handleDragOver = react_1.default.useCallback((event) => event.preventDefault(), []);
    const handleDragEnter = react_1.default.useCallback((event) => {
        event.preventDefault();
        setDragStatus(isValidFileInDragEvent(event) ? 'valid' : 'invalid');
    }, []);
    const handleDragLeave = react_1.default.useCallback((event) => {
        event.preventDefault();
        setDragStatus(undefined);
    }, []);
    const handleFileChange = react_1.default.useCallback((event) => {
        if (event.target.files) {
            const inputAccept = Array.isArray(props.fileInputAccept) ? props.fileInputAccept : [props.fileInputAccept];
            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                if (file) {
                    if (inputAccept.some((accept) => file.name.toLowerCase().endsWith(accept))) {
                        processFile(file);
                    }
                    else {
                        (0, DialogHelper_1.showErrorDialog)({
                            title: 'Not a ' + props.fileTypeLabel + ' selected',
                            onClose: () => undefined,
                        });
                    }
                    return;
                }
            }
        }
    }, [processFile, props.fileTypeLabel, props.fileInputAccept]);
    const handleSelectFileClick = react_1.default.useCallback(() => {
        if (file.current) {
            file.current.click();
        }
    }, []);
    if (props.file) {
        return react_1.default.createElement(AttachmentBox, { name: props.file.name, size: props.file.size, onRemoveAttachment: handleRemoveFile });
    }
    else {
        return (react_1.default.createElement(material_1.Box, { sx: {
                boxSizing: 'border-box',
                width: '100%',
                height: 224,
                padding: (theme) => theme.spacing(1),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px dashed ${JuvareTheme_1.themeColors.border.main}`,
                borderRadius: '1px',
                backgroundColor: JuvareTheme_1.themeColors.background,
            }, onDrop: handleDrop, onDragOver: handleDragOver, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragStart: handleDragEnter, onDragEnd: handleDragLeave, "data-test": 'select-file-area' },
            dragStatus === 'valid' && react_1.default.createElement(material_1.Typography, { sx: { pointerEvents: 'none' } },
                "Drop ",
                props.fileTypeLabel,
                " here..."),
            dragStatus === 'invalid' && react_1.default.createElement(material_1.Typography, { sx: { pointerEvents: 'none' } },
                "Not a ",
                props.fileTypeLabel),
            !dragStatus && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DriveFolderUpload_1.default, { sx: { mb: 1 }, color: 'primary' }),
                react_1.default.createElement(material_1.Typography, null,
                    "Drop ",
                    props.fileTypeLabel,
                    " here"),
                react_1.default.createElement(material_1.Typography, null, "or"),
                react_1.default.createElement("input", { ref: file, type: 'file', hidden: true, accept: Array.isArray(props.fileInputAccept) ? props.fileInputAccept.join(',') : props.fileInputAccept, onChange: handleFileChange }),
                react_1.default.createElement(material_1.Button, { variant: 'outlined', color: 'primary', onClick: handleSelectFileClick, "data-test": 'select-file-button' },
                    "Select ",
                    props.fileTypeLabel)))));
    }
};
exports.SelectFileArea = SelectFileArea;
function isValidFileInDragEvent(event) {
    if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind === 'file') {
                const file = event.dataTransfer.items[i];
                if (file) {
                    return true;
                }
            }
        }
    }
    else if (event.dataTransfer) {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const file = event.dataTransfer.files[i];
            if (file) {
                return true;
            }
        }
    }
    return false;
}
function findValidFileInDragEvent(event, fileInputAccept) {
    const inputAccept = Array.isArray(fileInputAccept) ? fileInputAccept : [fileInputAccept];
    if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind === 'file') {
                const file = event.dataTransfer.items[i].getAsFile();
                if (file && inputAccept.some((accept) => file.name.toLowerCase().endsWith(accept))) {
                    return file;
                }
            }
        }
    }
    else if (event.dataTransfer) {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const file = event.dataTransfer.files[i];
            if (file && inputAccept.some((accept) => file.name.toLowerCase().endsWith(accept))) {
                return file;
            }
        }
    }
    return undefined;
}
const AttachmentBox = ({ name, size = 0, onRemoveAttachment }) => {
    return (react_1.default.createElement(material_1.Box, { component: 'li', sx: {
            alignItems: 'center',
            background: (theme) => theme.palette.grey.A100,
            display: 'flex',
            justifyContent: 'space-between',
            p: 2,
        }, key: name },
        react_1.default.createElement(material_1.Typography, { variant: 'body2' },
            name,
            " (",
            (0, utils_1.humanFileSize)(size),
            ")"),
        react_1.default.createElement(material_1.IconButton, { color: 'inherit', size: 'small', "aria-label": 'remove file', onClick: () => onRemoveAttachment(), "data-test": 'delete-button' },
            react_1.default.createElement(Delete_1.default, null))));
};
